export const getData = (url, setData) => {
  fetch(url, { credentials: 'include' }).then((data) => data.json()).then(setData);
};
